import { graphql } from 'gatsby'

// eslint-disable-next-line no-restricted-exports
export { default } from './Author'

export const query = graphql`
  query ($slug: String!, $limit: Int!, $skip: Int!) {
    ghostAuthor(slug: { eq: $slug }) {
      ...GhostAuthorFields
    }
    allGhostPost(
      sort: { published_at: DESC }
      filter: { authors: { elemMatch: { slug: { eq: $slug } } } }
      limit: $limit
      skip: $skip
    ) {
      nodes {
        ...GhostPostFields
      }
    }
    allGhostPostRecent: allGhostPost(sort: { published_at: DESC }, limit: 5) {
      nodes {
        ...GhostPostFields
      }
    }
  }
`
